import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';

const log = new Logger('TRANSACTION_REPORT_INTRASTAT', LOG_LEVELS.DEBUG);

class ReportIntrastat extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.src) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <div>
        {this.props.src.map((item, index) => (
          <table key={index} className="mb20">
            <thead>
              <tr>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_country'/></td>
                <td>{item.country}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_countryOrigin'/></td>
                <td>{item.intrastatDetails.countryOrigin}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_reportingType'/></td>
                <td>{item.reportingType}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_transactionType'/></td>
                <td>{item.transactionType_str}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_countryDispatch'/></td>
                <td>{item.countryDispatch}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_supplierVATNumber'/></td>
                <td>{item.vatNumberSupplier}</td>             
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_countryArrival'/></td>
                <td>{item.countryArrival}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_customerVATNumber'/></td>
                <td>{item.vatNumberCustomer}</td>                
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_intrastatCode'/></td>
                <td>{item.intrastatDetails.intrastatCode}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_additionalDescription'/></td>
                <td>{item.intrastatDetails.additionalDescription}</td>                
              </tr>
              <tr>
                {
                  (() => {
                    if (item.reportingType === 1) {
                      return (
                        <>
                          <td className="semi-bold">
                            <LanguageStringResolver string="transactionInvoice_regionDispatch" />
                          </td>
                          <td>{item.intrastatDetails.regionDispatch}</td>
                          <td className="semi-bold">
                            <LanguageStringResolver string="transactionInvoice_harbourDispatch" />
                          </td>
                            <td>{item.intrastatDetails.harbourDispatch}</td>
                        </>
                      );
                    }
                    if (item.reportingType === 2) {
                      return (
                        <>
                          <td className="semi-bold">
                            <LanguageStringResolver string="transactionInvoice_regionArrival" />
                          </td>
                          <td>{item.intrastatDetails.regionArrival}</td>
                          <td className="semi-bold">
                            <LanguageStringResolver string="transactionInvoice_harbourArrival" />
                          </td>
                          <td>{item.intrastatDetails.harbourArrival}</td>
                        </>
                      );
                    }
                    return (
                      <>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </>
                    );
                  })()
                }
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_modeOfTransport'/></td>
                <td>{item.intrastatDetails.modeOfTransport_str}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_deliveryCondition'/></td>
                <td>{item.intrastatDetails.deliveryCondition}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_quantity1'/></td>
                <td>{item.intrastatDetails.quantity1}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_unit1'/></td>
                <td>{item.intrastatDetails.unit1}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_quantity2'/></td>
                <td>{item.intrastatDetails.quantity2 && item.intrastatDetails.quantity2 !== 0 ? item.intrastatDetails.quantity2 : ''}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_unit2'/></td>
                <td>{item.intrastatDetails.unit2}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_commercialValue'/></td>
                <td><span>{item.intrastatDetails.currency} <FormattedCurrencyValue value={item.intrastatDetails.commercialValue}/></span></td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_commercialValue2'/></td>
                <td><span>{item.intrastatDetails.currency2} <FormattedCurrencyValue value={item.intrastatDetails.commercialValue2}/></span></td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_statisticalValue'/></td>
                <td><span>{item.intrastatDetails.currency} <FormattedCurrencyValue value={item.intrastatDetails.statisticalValue}/></span></td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_statisticalValue2'/></td>
                <td><span>{item.intrastatDetails.currency2} <FormattedCurrencyValue value={item.intrastatDetails.statisticalValue2}/></span></td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_dataReferenceDocument'/></td>
                <td>{item.intrastatDetails.dataReferenceDocument}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_dataReferenceLine'/></td>
                <td>{item.intrastatDetails.dataReferenceDocumentLine}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_serviceCode'/></td>
                <td>{item.intrastatDetails.serviceCode}</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        ))}
      </div>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportIntrastat);
